import axios from "axios";
import { format, parseISO } from "date-fns";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cutString, minutesToDuration } from "../../../../helpers";
import * as dashboardActions from "../../../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../../../redux/reducers/dashboardReducer";
import EditScheduleClassPopover from './EditScheduleClassPopover';

import { TabPanel } from "@headlessui/react";
import moment from "moment";
import charetright from "../../../../assets/charetright.svg";
import { TwButton, TwFormHelperText, TwTabContainer } from "../../../../components/tailwind";
import TwDrawer from "../../../../components/tailwind/TwDrawer";
import { useLocalStorage } from "../../../../hooks";
import { loadingState } from "../../../../redux/reducers/loadingReducer";
import { getUrlForEvent } from "../../../../utils/confighelpers";
import { useTranslation } from "react-i18next";

export default function EditSchedules({
    setFormScheduleValues,
    edit = false,
    setLoading = null,
    reloadScheduleDetails,
    handleRadioValueChange = () => null,
    handleRadioValueChange2 = () => null,
    handleStartDateChange = () => null,
    handleEndDateChange = () => null,
    handleStartTimeChange = () => null,
    handleLocationChange = () => null,
    handleDaysInWeekChange = () => null,
    handleClearDaysInWeek = () => null,
    handleCalendarDaysChange = () => null,
    formValues = null,
    formErrors = null,
    handleSubmit,
    clearFormValues,
    isFromDetail = false
}) {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const loadingReduxState = useSelector(loadingState);
    const navigate = useNavigate();
    const [userToken] = useLocalStorage("userToken");
    const [isEdit, setIsEdit] = React.useState(-1);
    const [formPriceErrors, setFormPriceErrors] = React.useState({});
    const [eventPricingList, setEventPricingList] = React.useState([]);
    const [anchorEl, setAnchorEl] = React.useState(false);
    const [showAddDatesModal, setShowAddDatesModal] = React.useState(false);
    const [tabCurrentState, setTabCurrentState] = React.useState('1');

    const dashboardReduxState = useSelector(dashboardState);
    const sessionDataToDisplay = dashboardReduxState.calendarSessionData;
    const eventInfo = sessionDataToDisplay.eventId
    const durationObj = minutesToDuration(eventInfo?.duration || 15);

    const renderInstances = (listData) => {

        return (
            <div className="mt-5 overflow-x-auto">
                <div className="inline-block min-w-full py-2 align-middle sm:px-1 overflow-x-auto">
                    <div className="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-300">
                            <thead className="bg-form">
                                <tr>
                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 truncate">
                                        Date
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 truncate">

                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 truncate">
                                        Time
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 truncate">
                                        {t("myEvents.location")}
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 truncate">
                                        Ticket Sold
                                    </th>
                                    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                        <span className="sr-only">{t("account.tableActionHead")}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                                {(listData.length ? listData?.reverse()?.map((row, i) => {
                                    let seatsBooked = 0;
                                    let totalSeats = 0;
                                    row.eventPricingList.map((val, j) => {
                                        totalSeats = parseInt(totalSeats) + parseInt(val?.capacity)
                                        if (val?.ticketsBooked?.ticketsBookedConfirmed) {
                                            seatsBooked = parseInt(seatsBooked) + parseInt(val?.ticketsBooked?.ticketsBookedConfirmed)
                                        }
                                    });
                                    let seatsBookedPerc = (seatsBooked / totalSeats) * 100;

                                    return (
                                        <tr key={i}>
                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-bold text-gray-900 sm:pl-6 flex gap-2 items-center">
                                                <div>{moment(parseISO(row.eventDate)).format('DD MMM')}
                                                    <br />
                                                    <p>{moment(row.eventDate).format('yyyy')}</p>
                                                </div>
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                                                <div className="leading-[2.8rem]">
                                                    <span className="text-bz-status-red">&nbsp;{(row?.eventStatus && [/* 'Draft', 'Published',  */'cancelled', 'refunded'].indexOf(row?.eventStatus?.toLowerCase()) > -1) ? "CANCELLED" : ""}</span>
                                                </div>
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                                                <div>{format(parseISO(row.eventDate), "hh:mm aa") + " - " + format(parseISO(row.eventEndDate), "hh:mm aa")}
                                                    <p>{`${durationObj.hours} hr ${durationObj.mins} min`}</p>
                                                </div>
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                                                <div>{cutString(row?.location?.addressName, 25, true)}
                                                    <p>{cutString(row?.location?.address, 30, true)}</p>
                                                </div>
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                                                <div style={{ padding: "16px 16px" }}>
                                                    <div className={"flex flex-col items-center"}>
                                                        <div
                                                            className={"radial-progress text-light-primary w-[40px] h-[40px] after:bg-transparent"}
                                                            style={{
                                                                "--value": Number(seatsBookedPerc),
                                                                "--size": "3.5rem",
                                                                "--thickness": "1.5px",
                                                            }}
                                                        >
                                                            <div
                                                                className={
                                                                    "w-[35px] h-[35px] flex justify-center items-center bg-light-primary rounded-full border-2 border-white"
                                                                }
                                                            >
                                                                <p className={"font-bold text-white text-[8px]"}>
                                                                    {Number(seatsBookedPerc).toFixed(1)}%
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <h3
                                                            className={
                                                                "text-light-primary font-bold text-sm sm:text-sm md:text-sm lg:text-sm"
                                                            }
                                                        >
                                                            {seatsBooked}/{totalSeats}
                                                        </h3>
                                                        <p className={"text-xs text-center text-[#B5B5C3]"}>
                                                            {t("myEvents.ticketsBooked")}
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                {isFromDetail ? (
                                                    <div>
                                                        <img src={charetright} alt="" className="inline align-baseline my-4 mr-8 cursor-pointer" onClick={async () => {
                                                            const config = {
                                                                method: "get",
                                                                url: `${getUrlForEvent()}schedule/get?eventScheduleId=${row._id}&isPackage=${row.isPackage}`,
                                                                headers: {
                                                                    "x-access-token": userToken,
                                                                },
                                                            };
                                                            const request = await axios(config);
                                                            if (request.status === 200) {
                                                                if (request.data.statusCode === 200) {
                                                                    dispatch(dashboardActions.setCalendarClassData(request.data.data));
                                                                    dispatch(dashboardActions.setCalendarSessionId(row._id));
                                                                    dispatch(dashboardActions.setCalendarSessionData(request.data.data));
                                                                    dispatch(dashboardActions.setViewSessionPage(true));
                                                                    navigate("/myschedule/detail");
                                                                }
                                                            }
                                                        }} />
                                                    </div>
                                                ) : (<EditScheduleClassPopover
                                                    scheduleClassDetails={row}
                                                    handleUpdate={() => {
                                                        reloadScheduleDetails()
                                                    }}
                                                    setLoading={setLoading}
                                                />)}
                                            </td>
                                        </tr>
                                    )
                                }) : (
                                    <tr>
                                        <td colSpan={6} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                            No instances created
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    };


    return (
        <div className={`flex flex-col gap-2 ${isFromDetail === false ? "py-6 px-8 w-4/5" : "px-0"}`}>
            <div className={"flex gap-2 w-full"}>
                <div className={`items-left w-full text-2xl sm:text-3xl`}>
                    Event instances
                </div>
                <div className="flex justify-end w-full">
                    <TwButton
                        variant={"secondary"}
                        onClick={() => {
                            setShowAddDatesModal(true);
                        }}
                    >
                        Add Dates
                    </TwButton>
                </div>
            </div>
            <TwTabContainer
                tabs={[
                    {
                        name: "Upcoming", key: "1", onClick: () => { }, icon: null,
                    },
                    {
                        name: "Past", key: "2", onClick: () => { }, icon: null,
                    },
                ]}
            >
                <TabPanel value="1">
                    {renderInstances(sessionDataToDisplay?.allEventSchedules && sessionDataToDisplay?.allEventSchedules.length > 0 ? sessionDataToDisplay?.allEventSchedules.filter((d) => moment(d.eventDate).subtract({ hours: 0 }).isAfter()) : [])}
                </TabPanel>
                <TabPanel value="2">
                    {renderInstances(sessionDataToDisplay?.allEventSchedules && sessionDataToDisplay?.allEventSchedules.length > 0 ? sessionDataToDisplay?.allEventSchedules.filter((d) => moment(d.eventDate).subtract({ hours: 0 }).isBefore()) : [])}
                </TabPanel>
            </TwTabContainer>
            {formPriceErrors["eventPricingList"] && (
                <TwFormHelperText>{formPriceErrors["eventPricingList"]}</TwFormHelperText>
            )}
            <TwDrawer
                title={`Add Dates`}
                open={showAddDatesModal}
                showXBtn={false}
                onClose={() => {
                    clearFormValues();
                    setShowAddDatesModal(false);
                }}
                classNameDialogPanel={`!max-w-2xl`}
                footerChildren={(
                    <>
                        <TwButton
                            variant={"secondary-outline"}
                            className={"w-1/3"}
                            onClick={() => {
                                clearFormValues();
                                setShowAddDatesModal(false);
                            }}
                        >
                            {t("inputFieldsTitle.cancel")}
                        </TwButton>
                        <TwButton
                            variant={"secondary"}
                            className={"w-1/3 truncate"}
                            disabled={loadingReduxState.actionLoading}
                            actionLoading={(loadingReduxState.actionLoading)}
                            onClick={async () => {
                                let status = await handleSubmit();
                                if (status) {
                                    clearFormValues()
                                    setShowAddDatesModal(false);
                                    await reloadScheduleDetails()
                                }
                            }}
                        >
                            {(isEdit >= 0) ? t("update") : t("myEvents.addAddon")}
                        </TwButton>
                    </>)}
            >
                <div className={"flex flex-col gap-3"}>
                    {/* <EditAddScheduleDate
                        handleRadioValueChange={handleRadioValueChange}
                        handleRadioValueChange2={handleRadioValueChange2}
                        handleStartDateChange={handleStartDateChange}
                        handleEndDateChange={handleEndDateChange}
                        handleStartTimeChange={handleStartTimeChange}
                        handleLocationChange={handleLocationChange}
                        handleDaysInWeekChange={handleDaysInWeekChange}
                        handleClearDaysInWeek={handleClearDaysInWeek}
                        handleCalendarDaysChange={handleCalendarDaysChange}
                        formValues={formValues}
                        formErrors={formErrors}
                        setLoading={setLoading}
                    /> */}
                </div>
            </TwDrawer>
        </div>
    );
}
